import React, { useEffect, useState } from 'react';
import { Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useCommon } from 'hooks/useCommon';
import { toast } from 'react-toastify';

/* Generic key/value form backed by one CommonItem document */
const CommonItemForm = ({ title, itemKey, fields }) => {
    const { items, updateItem, isUpdating } = useCommon();
    const [values, setValues] = useState({});

    useEffect(() => {
        const item = items?.[itemKey] || {};
        setValues(fields.reduce((acc, f) => ({ ...acc, [f.name]: item[f.name] || '' }), {}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items, itemKey]);

    const onSave = () => {
        const existing = items?.[itemKey] || {};
        updateItem({ key: itemKey, files: existing.files, textArea: existing.textArea, ...values }, () =>
            toast.success('Saved')
        );
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" color="primary.main" fontWeight={600} sx={{ mb: 2 }}>
                    {title}
                </Typography>
                <Stack spacing={2}>
                    {fields.map((f) => (
                        <TextField
                            key={f.name}
                            label={f.label}
                            fullWidth
                            value={values[f.name] || ''}
                            onChange={(e) => setValues({ ...values, [f.name]: e.target.value })}
                        />
                    ))}
                    <LoadingButton variant="contained" loading={isUpdating} onClick={onSave}>
                        Save
                    </LoadingButton>
                </Stack>
            </CardContent>
        </Card>
    );
};

export default CommonItemForm;
